import {
  monthNames,
  months,
  organicMarketingChannels,
} from "@/constants/common";
import { ScrollSelectOptionType } from "@/types/registration";

import { getCookie } from "./cookies";

export const loadScript = (src: string) => {
  const scriptElement = document.createElement("script");
  scriptElement.src = src;
  scriptElement.defer = true;
  document.body.appendChild(scriptElement);
};

let timer: NodeJS.Timeout;
export const debounce = (fn: () => void, delay = 300) => {
  return (() => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(), delay);
  })();
};

const PAGES: Record<string, string[]> = {
  "Job Details": ["/job"],
  Home: ["/", "/user"],
};

const PAGE_NAME_MAPPING: Record<string, string> = {};
for (const [pageName, paths] of Object.entries(PAGES)) {
  paths.forEach((path) => {
    PAGE_NAME_MAPPING[path] = pageName;
  });
}

export const getPageName = (url: string | null) => {
  const pathName = "/" + (url?.split("/")[1] || "");
  return PAGE_NAME_MAPPING[pathName] || "Home";
};

export const clearHTMLTags = (strToSanitize: string) => {
  return strToSanitize.replace(/(<([^>]+)>)/gi, "");
};

let internalNetworkCode: string | number = "";
export const networkCode = {
  get: () => internalNetworkCode,
  set: (nc: string | number) => (internalNetworkCode = nc),
};

export const getOS = () => {
  let OSName = "Unknown";
  if (navigator.userAgent.indexOf("Windows") != -1) OSName = "Windows";
  if (navigator.userAgent.indexOf("Mac OS") != -1) OSName = "MacOS";
  if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
  if (navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";

  return OSName;
};

export const getMarketingChannel = (spl: string) => {
  if (spl) return "Paid";
  else {
    let ref = getCookie("ref");
    if (ref) {
      for (const organic of organicMarketingChannels) {
        if (ref.toUpperCase().includes(organic?.toUpperCase()))
          return "Organic";
      }

      if (ref.toUpperCase().includes("FOUNDIT")) return "Direct";
      else return "Other";
    } else return "Direct";
  }
};
export const getProfileExperience = (years: number, months: number): string => {
  return `${years + (months >= 5 ? 1 : 0)} years`;
};

export function getYearData(upto = 20, startYear?: number | undefined) {
  if (startYear === undefined) {
    let date = new Date();
    startYear = date.getFullYear();
  }
  const yearData: ScrollSelectOptionType[] = [];
  for (let i = 0; i < upto; i++) {
    yearData.push({
      id: i,
      text: `${startYear - i}`,
      value: i,
    });
  }
  return yearData;
}

export const getMonthData = (upto = 1, startMonth = 1) => {
  // 1 based index
  const monthData: { text: string; value: string; id: number }[] = months.slice(
    startMonth - 1,
    startMonth - 1 + upto,
  );
  return monthData;
};

export const getNext12Months = () => {
  const today = new Date();
  const monthList = [];

  const formatMonth = (date: Date, id: number) => {
    const month = monthNames[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2);

    return {
      id: id,
      text: `${month} '${year}`,
      value: `${date.getFullYear()}-${date.getMonth() + 1}`,
      month: date.getMonth(),
      year: date.getFullYear(),
    };
  };

  for (let i = 0; i < 12; i++) {
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + i);
    monthList.push(formatMonth(nextMonth, i));
  }

  return monthList;
};

export const getDates = (year: string, month: string) => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth();
  const currentDate = date.getDate();

  const daysInMonth = new Date(
    parseInt(year),
    parseInt(month) + 1,
    0,
  ).getDate();

  let datesArray = [];
  let startDate =
    parseInt(year) === currentYear && parseInt(month) === currentMonth
      ? currentDate
      : 1;

  for (let day = startDate; day <= daysInMonth; day++) {
    datesArray.push({ id: day, text: day, value: day });
  }

  return datesArray;
};

export const getLocalTimeFormatDate = (isoLike: string): string => {
  const d = new Date(isoLike);
  if (isNaN(d.getTime())) throw new Error("Invalid date");

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};
